export default {"src":"/_next/static/media/logo-word-light.e7b56690.svg","height":36,"width":153,"blurWidth":0,"blurHeight":0};